import {charcoal} from '../../sass/v2/_exports.sass';

export const LinkIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2867 15.0572C12.7974 13.5466 15.432 13.5466 16.9427 15.0572L17.8854 15.9999L19.7707 14.1146L18.828 13.1719C17.5707 11.9132 15.896 11.2186 14.1147 11.2186C12.3334 11.2186 10.6587 11.9132 9.40137 13.1719L6.57203 15.9999C5.32443 17.2515 4.62386 18.9467 4.62386 20.7139C4.62386 22.4811 5.32443 24.1763 6.57203 25.4279C7.19053 26.0473 7.92532 26.5384 8.73419 26.8729C9.54306 27.2074 10.4101 27.3788 11.2854 27.3772C12.1609 27.3791 13.0282 27.2078 13.8373 26.8732C14.6464 26.5387 15.3814 26.0475 16 25.4279L16.9427 24.4852L15.0574 22.5999L14.1147 23.5426C13.3633 24.2906 12.3463 24.7105 11.286 24.7105C10.2258 24.7105 9.20874 24.2906 8.45737 23.5426C7.7087 22.7915 7.28831 21.7744 7.28831 20.7139C7.28831 19.6535 7.7087 18.6363 8.45737 17.8852L11.2867 15.0572Z"
        fill={color}
      />
      <path
        d="M16 6.57198L15.0573 7.51465L16.9427 9.39998L17.8853 8.45731C18.6367 7.7093 19.6538 7.28935 20.714 7.28935C21.7742 7.28935 22.7913 7.7093 23.5427 8.45731C24.2913 9.20834 24.7117 10.2255 24.7117 11.286C24.7117 12.3464 24.2913 13.3636 23.5427 14.1146L20.7133 16.9426C19.2027 18.4533 16.568 18.4533 15.0573 16.9426L14.1147 16L12.2293 17.8853L13.172 18.828C14.4293 20.0866 16.104 20.7813 17.8853 20.7813C19.6667 20.7813 21.3413 20.0866 22.5987 18.828L25.428 16C26.6756 14.7484 27.3762 13.0532 27.3762 11.286C27.3762 9.51876 26.6756 7.8236 25.428 6.57198C24.1767 5.32372 22.4814 4.62271 20.714 4.62271C18.9466 4.62271 17.2513 5.32372 16 6.57198Z"
        fill={color}
      />
    </svg>
  );
};
